
import { useEffect, useState } from "react";


    const WhyUs = () =>{
    return(<>
    
    
    {/* <!-- Breadcumb Section Start --> */}
    <div className="breadcrumb-img">
     <img src="assets/img/banner/about-banner.jpg" alt="MeriPustak-About"/>
       
    </div>

    {/* <!-- About Section Start --> */}
    <section className="about-section fix section-padding">
        <div className="container">
            <div className="about-wrapper">
			
                <div className="row g-4 align-items-center text-center">
                    <div className="col-lg-12">
                        <div className="about-content">
                           <h2 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Our Approach</h2>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                              Our approach is to combine our understanding of user behaviour with a commitment to meeting the needs of our customers. We are proactive in our aftercare service and will alert our customers of any malicious behaviour that we find. We as a team diverse and talented in all aspects of book knowledge website technology. We love what we do and it shows in the service which we provide.</p>
                        </div>
                    </div>
                </div>
				<div className="row g-4 align-items-center text-center">
                    <div className="col-lg-12">
                        <div className="about-content">
                           <h2 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Our Values</h2>
                           
                        </div>
                    </div>
                </div>
				<div className="row g-4 align-items-center col-con">
                    <div className="col-lg-4 values">
                        <div className="about-content value">
							 <img src="assets/img/icon/quality.png" alt="MeriPustak-Quality"/>
                           <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Quality</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                             We strive for excellence in all that we do. We set high personal and company standards, and then consistently try to exceed them. We attract self-motivated, highly capable, results-oriented people and invest heavily in their development.</p>
                        </div>
                    </div>
					<div className="col-lg-4 values">
                        <div className="about-content value">
							<img src="assets/img/icon/honesty.png" alt="MeriPustak-Openness & Honesty"/>
                           <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Openness & Honesty</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                             We believe that open communication builds trust, which is the foundation of any relationship whether it’s with our team or our customers.</p>
                        </div>
                    </div>
					<div className="col-lg-4 values">
                        <div className="about-content value">
							<img src="assets/img/icon/team.png" alt="MeriPustak-Teamwork"/>
                           <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Teamwork</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                              Our power comes from the talented people within our company. We create an environment in which every person is a valued and respected member, encouraged to contribute and share, and recognized and rewarded for their efforts.</p>
                        </div>
                    </div>
                </div>
				<div className="row g-4 align-items-center col-con">
                    <div className="col-lg-4 values">
                        <div className="about-content value">
							<img src="assets/img/icon/flexibility.png" alt="MeriPustak-Flexibility"/>
                           <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Flexibility</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                             We believe that flexibility leads to excellence and we tailor all our services to the specific needs of each client.</p>
                        </div>
                    </div>
					<div className="col-lg-4 values">
                        <div className="about-content value">
							<img src="assets/img/icon/passion.png" alt="MeriPustak-Passion"/>
                           <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Passion</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                             We are passionate and committed in heart and mind to what we do. Our team work around the clock coming up with ideas.</p>
                        </div>
                    </div>
					<div className="col-lg-4 values">
                        <div className="about-content value">
							<img src="assets/img/icon/integrity.png" alt="MeriPustak-Integrity"/>
                           <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Integrity</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                              When we face a tough decision we never compromise our values and principles. We do what is right, not what is the easiest.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>);
    }
export default WhyUs;